<template>
    <v-container fluid>
        <div>
            <TitleBar title="Gestão de Fatores" url="/swot/menu"/>
        </div>
        <v-row class="mt-2">
            <v-col cols="3" v-show="showSidebar">
                <SectorTreeList @selected="setSector"/>
            </v-col>
            <v-col :cols="showSidebar ? 9 : 12">
                <v-toolbar flat dense class="mb-2">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on" @click="showSidebar = !showSidebar">
                                <v-icon>{{ showSidebar ? 'mdi-chevron-double-left' : 'mdi-chevron-double-right' }}</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ showSidebar ? 'Ocultar' : 'Exibir' }} árvore de setores</span>
                    </v-tooltip>
                    <template v-if="sector.id">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-toolbar-title
                                    v-bind="attrs"
                                    v-on="on"
                                    class="subtitle-1 sector-name-btn"
                                    @click="showSidebar = !showSidebar"
                                >
                                    <v-icon small color="primary" class="mr-1">mdi-sitemap</v-icon>
                                    {{ sector.name }}
                                </v-toolbar-title>
                            </template>
                            <span>Clique para {{ showSidebar ? 'ocultar' : 'exibir' }} a árvore de setores</span>
                        </v-tooltip>
                    </template>
                    <v-toolbar-title v-else class="subtitle-1">
                        {{ $t('kpi.selectSector') }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        v-if="selectionMode && selectedFactors.length > 0"
                        @click="deleteSelectedFactors"
                        color="red"
                        dark
                        class="mr-2"
                    >
                        <v-icon left>mdi-delete</v-icon>Excluir Selecionados ({{ selectedFactors.length }})
                    </v-btn>
                    <v-btn
                        @click="toggleSelectionMode"
                        :color="selectionMode ? 'grey darken-1' : 'purple'"
                        :outlined="selectionMode"
                        :dark="!selectionMode"
                        class="mr-2"
                        :disabled="!sector.id"
                    >
                        <v-icon left>{{ selectionMode ? 'mdi-close' : 'mdi-checkbox-marked-outline' }}</v-icon>{{ selectionMode ? 'CANCELAR' : 'SELECIONAR' }}
                    </v-btn>
                    <v-btn @click="openFactorForm(null)" color="purple" dark :disabled="!sector.id">
                        <v-icon left>mdi-plus</v-icon>{{ $t('common.new') }}
                    </v-btn>
                </v-toolbar>

                <div v-if="loading"><LoaderShow /></div>
                <div v-else-if="sector.id">
                 <div class="mt-4">
                    <!-- Ambientes Internos -->
                    <v-card class="mb-4">
                        <v-card-title class="subtitle-1 font-weight-bold grey lighten-4">
                            Ambientes Internos
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <div class="text-overline green--text">Forças</div>
                                    <div v-for="factor in sortedFactors('strength')" :key="factor.id" class="mb-2">
                                        <v-card outlined @click="openFactorForm(factor)" class="cursor-pointer">
                                            <v-list-item>
                                                <v-list-item-action v-if="selectionMode" @click.stop>
                                                    <v-checkbox
                                                        :input-value="isFactorSelected(factor.id)"
                                                        @change="toggleFactorSelection(factor.id)"
                                                        hide-details
                                                        dense
                                                        class="mt-0 pt-0"
                                                    ></v-checkbox>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-list-item-title v-bind="attrs" v-on="on" class="font-weight-bold text-truncate">{{ factor.code }} - {{ factor.description }}</v-list-item-title>
                                                        </template>
                                                        <span>{{ factor.code }} - {{ factor.description }}</span>
                                                    </v-tooltip>
                                                    <v-list-item-subtitle>
                                                        Peso: {{ factor.weight }} | Class: {{ factor.rating }} | Total: {{ (factor.weight * factor.rating).toFixed(2) }}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <v-chip small :color="factor.active ? 'green' : 'grey'" dark>{{ factor.active ? 'Ativo' : 'Inativo' }}</v-chip>
                                                </v-list-item-action>
                                            </v-list-item>
                                        </v-card>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <div class="text-overline orange--text">Fraquezas</div>
                                    <div v-for="factor in sortedFactors('weakness')" :key="factor.id" class="mb-2">
                                        <v-card outlined @click="openFactorForm(factor)" class="cursor-pointer">
                                            <v-list-item>
                                                <v-list-item-action v-if="selectionMode" @click.stop>
                                                    <v-checkbox
                                                        :input-value="isFactorSelected(factor.id)"
                                                        @change="toggleFactorSelection(factor.id)"
                                                        hide-details
                                                        dense
                                                        class="mt-0 pt-0"
                                                    ></v-checkbox>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-list-item-title v-bind="attrs" v-on="on" class="font-weight-bold text-truncate">{{ factor.code }} - {{ factor.description }}</v-list-item-title>
                                                        </template>
                                                        <span>{{ factor.code }} - {{ factor.description }}</span>
                                                    </v-tooltip>
                                                    <v-list-item-subtitle>
                                                        Peso: {{ factor.weight }} | Class: {{ factor.rating }} | Total: {{ (factor.weight * factor.rating).toFixed(2) }}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <v-chip small :color="factor.active ? 'green' : 'grey'" dark>{{ factor.active ? 'Ativo' : 'Inativo' }}</v-chip>
                                                </v-list-item-action>
                                            </v-list-item>
                                        </v-card>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <!-- Ambientes Externos -->
                    <v-card>
                        <v-card-title class="subtitle-1 font-weight-bold grey lighten-4">
                            Ambientes Externos
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <div class="text-overline blue--text">Oportunidades</div>
                                    <div v-for="factor in sortedFactors('opportunity')" :key="factor.id" class="mb-2">
                                        <v-card outlined @click="openFactorForm(factor)" class="cursor-pointer">
                                            <v-list-item>
                                                <v-list-item-action v-if="selectionMode" @click.stop>
                                                    <v-checkbox
                                                        :input-value="isFactorSelected(factor.id)"
                                                        @change="toggleFactorSelection(factor.id)"
                                                        hide-details
                                                        dense
                                                        class="mt-0 pt-0"
                                                    ></v-checkbox>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-list-item-title v-bind="attrs" v-on="on" class="font-weight-bold text-truncate">{{ factor.code }} - {{ factor.description }}</v-list-item-title>
                                                        </template>
                                                        <span>{{ factor.code }} - {{ factor.description }}</span>
                                                    </v-tooltip>
                                                    <v-list-item-subtitle>
                                                        Peso: {{ factor.weight }} | Class: {{ factor.rating }} | Total: {{ (factor.weight * factor.rating).toFixed(2) }}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <v-chip small :color="factor.active ? 'green' : 'grey'" dark>{{ factor.active ? 'Ativo' : 'Inativo' }}</v-chip>
                                                </v-list-item-action>
                                            </v-list-item>
                                        </v-card>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <div class="text-overline red--text">Ameaças</div>
                                    <div v-for="factor in sortedFactors('threat')" :key="factor.id" class="mb-2">
                                        <v-card outlined @click="openFactorForm(factor)" class="cursor-pointer">
                                            <v-list-item>
                                                <v-list-item-action v-if="selectionMode" @click.stop>
                                                    <v-checkbox
                                                        :input-value="isFactorSelected(factor.id)"
                                                        @change="toggleFactorSelection(factor.id)"
                                                        hide-details
                                                        dense
                                                        class="mt-0 pt-0"
                                                    ></v-checkbox>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-list-item-title v-bind="attrs" v-on="on" class="font-weight-bold text-truncate">{{ factor.code }} - {{ factor.description }}</v-list-item-title>
                                                        </template>
                                                        <span>{{ factor.code }} - {{ factor.description }}</span>
                                                    </v-tooltip>
                                                    <v-list-item-subtitle>
                                                        Peso: {{ factor.weight }} | Class: {{ factor.rating }} | Total: {{ (factor.weight * factor.rating).toFixed(2) }}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <v-chip small :color="factor.active ? 'green' : 'grey'" dark>{{ factor.active ? 'Ativo' : 'Inativo' }}</v-chip>
                                                </v-list-item-action>
                                            </v-list-item>
                                        </v-card>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                 </div>
                </div>
                <div v-else>
                    {{ $t('kpi.selectSector') }}
                </div>
            </v-col>
        </v-row>

        <!-- Modal de Formulário -->
        <v-dialog v-model="dialog" width="800" scrollable>
            <FactorForm
                v-if="dialog"
                :factor="selectedFactor"
                :sectorName="sector.name"
                @save="handleSaveFactor"
                @delete="handleDeleteFactor"
                @close="dialog = false"
            />
        </v-dialog>
    </v-container>
</template>

<script>
import SectorTreeList from '../../../components/app/operative/SectorTreeList.vue';
import TitleBar from '../../../components/app/TitleBar.vue';
import LoaderShow from '../../../components/app/LoaderShow.vue';
import FactorForm from '../../../components/app/swot/FactorForm.vue';
import swotService from '@/services/swotService';

export default {
    name: 'FactorManagement',
    components: { TitleBar, SectorTreeList, LoaderShow, FactorForm },
    data() {
        return {
            loading: false,
            dialog: false,
            showSidebar: false,
            sector: { id: null },
            factors: [],
            selectedFactor: null,
            selectionMode: false,
            selectedFactors: []
        };
    },
    methods: {
        sortedFactors(type) {
            return this.factors
                .filter(f => f.type === type)
                .sort((a, b) => (a.code || '').localeCompare(b.code || '', undefined, { numeric: true }));
        },
        setSector(sector) {
            if (!sector) return;
            this.sector = sector;
            this.selectionMode = false;
            this.selectedFactors = [];
            this.loadFactors();
        },
        toggleSelectionMode() {
            this.selectionMode = !this.selectionMode;
            if (!this.selectionMode) {
                this.selectedFactors = [];
            }
        },
        loadFactors() {
            if (!this.sector.id) return;
            const stageId = this.$store.state.current.stage && this.$store.state.current.stage.id;
            if (!stageId) return;
            this.loading = true;
            swotService.getFactors(this.sector.id, stageId)
                .then(resp => { this.factors = resp.data; })
                .catch(() => { this.$toastr && this.$toastr.e('Erro ao carregar fatores.'); })
                .finally(() => { this.loading = false; });
        },
        isFactorSelected(id) {
            return this.selectedFactors.includes(id);
        },
        toggleFactorSelection(id) {
            const idx = this.selectedFactors.indexOf(id);
            if (idx === -1) {
                this.selectedFactors.push(id);
            } else {
                this.selectedFactors.splice(idx, 1);
            }
        },
        deleteSelectedFactors() {
            const count = this.selectedFactors.length;
            if (count === 0) return;
            const message = count === 1
                ? 'Tem certeza que deseja excluir o fator selecionado?'
                : `Tem certeza que deseja excluir os ${count} fatores selecionados?`;
            if (!confirm(message)) return;
            Promise.all(this.selectedFactors.map(id => swotService.deleteFactor(id)))
                .then(() => {
                    this.$toastr && this.$toastr.s('Fatores excluídos.');
                    this.selectedFactors = [];
                    this.loadFactors();
                })
                .catch(() => { this.$toastr && this.$toastr.e('Erro ao excluir fatores selecionados.'); });
        },
        openFactorForm(factor) {
            this.selectedFactor = factor;
            this.dialog = true;
        },
        handleDeleteFactor(id) {
            if (!confirm('Tem certeza que deseja excluir este fator?')) return;
            swotService.deleteFactor(id)
                .then(() => {
                    this.$toastr && this.$toastr.s('Fator excluído.');
                    const idx = this.selectedFactors.indexOf(id);
                    if (idx !== -1) this.selectedFactors.splice(idx, 1);
                    this.loadFactors();
                })
                .catch(() => { this.$toastr && this.$toastr.e('Erro ao excluir fator.'); })
                .finally(() => { this.dialog = false; });
        },
        handleSaveFactor(factorToSave) {
            const stageId = this.$store.state.current.stage && this.$store.state.current.stage.id;
            const payload = { ...factorToSave, sectorId: this.sector.id, stageId };
            const request = payload.id
                ? swotService.updateFactor(payload)
                : swotService.saveFactor(payload);
            request
                .then(() => { this.loadFactors(); })
                .catch(() => { this.$toastr && this.$toastr.e('Erro ao salvar fator.'); })
                .finally(() => { this.dialog = false; });
        }
    }
};
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
}
.cursor-pointer:hover {
    background-color: #f5f5f5;
}
.sector-name-btn {
    cursor: pointer;
    color: var(--v-primary-base, #1976d2);
    border-bottom: 1px dashed currentColor;
    transition: opacity 0.15s ease;
}
.sector-name-btn:hover {
    opacity: 0.75;
}
</style>
